import { render, staticRenderFns } from "./AdminMessageDraft.vue?vue&type=template&id=7a24f0e4&scoped=true"
import script from "./AdminMessageDraft.vue?vue&type=script&lang=js"
export * from "./AdminMessageDraft.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageDraft.vue?vue&type=style&index=0&id=7a24f0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24f0e4",
  null
  
)

export default component.exports